/**
 * Checkout Selectors
 *
 * Memoized selectors for accessing flight checkout state.
 * Using createSelector ensures components only re-render when selected data changes.
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

// ============================================
// Base Selectors
// ============================================

const selectCheckoutState = (state: RootState) => state.flights.checkout;

// ============================================
// Checkout Selectors (Memoized)
// ============================================

export const selectCheckoutUrl = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.checkoutUrl,
);

// ============================================
// Prebook Selectors (Memoized)
// ============================================

export const selectPrebookLoading = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.prebook.isLoading,
);

export const selectPrebookError = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.prebook.error,
);

export const selectPrebookErrorDetails = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.prebook.errorDetails,
);

// ============================================
// Traveller Validation Selectors (Memoized)
// ============================================

export const selectTravellerValidationLoading = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.travellerValidation.isLoading,
);

export const selectTravellerValidationError = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.travellerValidation.error,
);
